import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { commonCardMarketplaceFragment } from '@sorare/core/src/contexts/currentUser/queries';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import { RewardBoxDialogWithOnboarding } from 'components/rewards/RewardBoxDialogWithOnboarding';

import type {
  ClaimFootballManagerTaskMutation,
  ClaimFootballManagerTaskMutationVariables,
} from './__generated__/useClaimManagerTask.graphql';

const CLAIM_FOOTBALL_MANAGER_TASK_MUTATION = gql`
  mutation ClaimFootballManagerTaskMutation(
    $input: claimFootballManagerTaskInput!
    $sport: Sport!
  ) {
    claimFootballManagerTask(input: $input) {
      currentUser {
        slug
        baseballUserProfile {
          id
          dailyClaimTasks {
            id
            aasmState
            label
            readyAt
          }
        }
        ...commonCardMarketplace_currentUser
      }
      footballManagerTask {
        id
        aasmState
        claimedAt
        probabilisticBundle {
          id
          config {
            id
            rarity
          }
          ...RewardBoxDialogWithOnboarding_probabilisticBundle
        }
        cards {
          slug
          pictureUrl
          rarityTyped
          anyPlayer {
            slug
            displayName
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
  ${RewardBoxDialogWithOnboarding.fragments.probabilisticBundle}
  ${commonCardMarketplaceFragment}
` as TypedDocumentNode<
  ClaimFootballManagerTaskMutation,
  ClaimFootballManagerTaskMutationVariables
>;

export const useClaimManagerTask = () => {
  return useMutation(CLAIM_FOOTBALL_MANAGER_TASK_MUTATION);
};
